import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";

import { EditCountryIcon } from "../../../assets";
import { ERROR_TOAST } from "../../../constants/toast.constants";
import { EMPTY_STRING, privacyPolicyConstants } from "../../../constants";
import { customToast, isEditorEmpty } from "../../../shared/utility";
import MainSpinner from "../../../shared/components/spinner/MainSpinner";
import RoundedButton from "../../../shared/components/buttons/RoundedButton";
import RichTextEditor from "../../../shared/components/editor/RichTextEditor";
import convertContentToHTML from "../../../shared/utility-functions/ConvertContentToHtml";
import MainContentWrapper from "../../../shared/components/main-content-wrapper/MainContentWrapper";
import { privacyPolicyActions } from "../../../redux/actions";

const { GET_PRIVACY_POLICY } = privacyPolicyConstants;

const AdminPrivacyPolicy = ({
  getPrivacyPolicy,
  privacyPolicy,
  spinnerActions,
  addOrUpdatePrivacyPolicy,
}) => {
  const [content, setContent] = useState(EMPTY_STRING);
  const [htmlContent, setHtmlContent] = useState(EMPTY_STRING);

  const [isEditing, setIsEditing] = useState(false);

  const handleContentChange = (newContent) => {
    setContent(newContent);
  };

  const spinner = useCallback(
    (type) => {
      return spinnerActions.findIndex((s) => s === type);
    },
    // eslint-disable-next-line
    [spinnerActions]
  );

  const handleSave = () => {
    if (isEditorEmpty(content)) {
      customToast("Privacy policy must not be empty", ERROR_TOAST);
      return;
    }
    addOrUpdatePrivacyPolicy({ ...privacyPolicy, content: content }, () => {
      setIsEditing(false);
      getPrivacyPolicy();
    });
  };

  useEffect(() => {
    if (privacyPolicy?.content) {
      const html = convertContentToHTML(privacyPolicy.content);
      setHtmlContent(html);
    }
  }, [privacyPolicy]);

  useEffect(() => {
    getPrivacyPolicy();

    // eslint-disable-next-line
  }, []);

  return (
    <MainContentWrapper>
      {spinner(GET_PRIVACY_POLICY) > -1 && (
        <MainSpinner className="admin-spinner" />
      )}
      <div className="d-flex align-items-center justify-content-between">
        <div className="admin-page-heading">Privacy Policy</div>
        {!isEditing && (
          <div
            className="d-flex justify-content-end align-items-center gap-1 pointer"
            onClick={() => setIsEditing(true)}
          >
            <img
              src={EditCountryIcon}
              className="edit-country-info-image"
              alt="Edit"
            />
            <div className="edit-country-info-text">Edit</div>
          </div>
        )}
      </div>
      {spinner(GET_PRIVACY_POLICY) === -1 && (
        <>
          {isEditing && (
            <>
              <RichTextEditor
                onContentChange={handleContentChange}
                initialContent={privacyPolicy?.content ?? EMPTY_STRING}
              />
              <div className="agent-approval-buttons-container d-flex justify-content-center gap-3 mt-5">
                <RoundedButton onClick={handleSave}>Update</RoundedButton>
                <RoundedButton
                  type="button"
                  className="reject-button reject-button-outlined"
                  onClick={() => setIsEditing(false)}
                >
                  Cancel
                </RoundedButton>
              </div>
            </>
          )}
          {!isEditing && (
            <div
              dangerouslySetInnerHTML={{ __html: htmlContent }}
              className="html-content"
            />
          )}
        </>
      )}
    </MainContentWrapper>
  );
};

const mapStateToProps = (state) => ({
  privacyPolicy: state.privacyPolicyReducer.privacyPolicy,
  spinnerActions: state.systemReducer.spinnerActions,
});

const mapDispatchToProps = (dispatch) => ({
  getPrivacyPolicy: () => dispatch(privacyPolicyActions.getPrivacyPolicy()),
  addOrUpdatePrivacyPolicy: (data, func) =>
    dispatch(privacyPolicyActions.addOrUpdatePrivacyPolicy(data, func)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminPrivacyPolicy);
